export default "__VITE_ASSET__yyt4hYlE__"